import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Resources API
export const resourcesAPI = {
  getAll: (params = {}) => api.get('/resources', { params }),
  getByModule: (module) => api.get('/resources', { params: { module } }),
  getById: (id) => api.get(`/resources/${id}`),
  getTypes: () => api.get('/resources/types'),
  getCategories: (params = {}) => api.get('/resources/categories', { params }),
  create: (data) => {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('typeId', data.typeId);
    formData.append('categoryId', data.categoryId);
    formData.append('file', data.file);

    return api.post('/resources', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  update: (id, data) => {
    if (data.file) {
      const formData = new FormData();
      formData.append('name', data.name);
      formData.append('description', data.description);
      formData.append('typeId', data.typeId);
      formData.append('categoryId', data.categoryId);
      formData.append('file', data.file);

      return api.put(`/resources/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }
    return api.put(`/resources/${id}`, data);
  },
  delete: (id) => api.delete(`/resources/${id}`),
  download: (id, params = {}) => api.get(`/resources/${id}/download`, {
    params,
    responseType: 'blob',
  }),
};

export default api;
